exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.vue-input-tag-wrapper.invite-emails .new-tag {\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n.invite-row .group-dropdown .trigger {\n  max-width: 110px;\n}\n", "", {"version":3,"sources":["/Users/Razvan/Documents/projects/archii/website-new/apps/account/Team.vue"],"names":[],"mappings":";AAAA;EACE,UAAU;EACV,WAAW;EACX,aAAa;CAAE;AAEjB;EACE,iBAAiB;CAAE","file":"Team.vue","sourcesContent":[".vue-input-tag-wrapper.invite-emails .new-tag {\n  margin: 0;\n  padding: 0;\n  border: none; }\n\n.invite-row .group-dropdown .trigger {\n  max-width: 110px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-414b6ffe","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./apps/account/Team.vue
// module id = 495
// module chunks = 0